import React from "react";
import { KEY_GENERATOR } from "../../functions/funtion";
import { Colors } from "../../util/colors";
import FlagMV from "./flagMV.png";
import FlagSL from "./flagSL.png";
import "../../styles/css/pg-home-drawer-zone-table.css";

const countries = [
    { countrycode: "LK", logourl: FlagSL, startingNo: "+94" },
    { countrycode: "MV", logourl: FlagMV, startingNo: "+960" },
]

export default class RENDER_DRAWER_COUNTRY extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isClosedrawer: false,
        };
    }
    render() {
        return (
            <table id="pg-home-drawer-zone-table">
                <thead>
                    <tr>
                        <th
                            style={{
                                backgroundColor: Colors.ThemeBGcolor,
                                color: Colors.FontColor,
                            }}
                        >
                            Countries
                        </th>
                        <th
                            style={{
                                backgroundColor: Colors.ThemeBGcolor,
                                color: Colors.FontColor,
                            }}
                        ></th>
                    </tr>
                </thead>
                <tbody>
                    {countries.map((rs) => {
                        return (
                            <tr
                                key={KEY_GENERATOR()}
                                onClick={() => {
                                    this.props.SelectCountry(rs);
                                }}
                            >
                                <td style={{ display: 'none' }}>{rs.countrycode}</td>
                                <td style={{ textAlign: "center" }}>
                                    <img src={(rs.logourl)} alt="logo" width="50" />
                                </td>
                                <td style={{}}>{rs.startingNo}</td>
                                {/* <td style={{ textAlign: "center" }}>
                                    <i
                                        className="fa fa-arrow-circle-right"
                                        aria-hidden="true"
                                    ></i>
                                </td> */}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }
}
